/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react'
import SearchableSelect from '../SearchableSelect/SearchableSelect'
import {getKodBojeDropdown} from '../../api'
import {Option} from '../../models/Sektor'

// kodBojeRepromaterijalaDropdown Props for the component
interface DropdownProps {
  value?: string | number
  initialValue?: string | number
  onChange?: (name: string, value: any) => void
  errors?: string | undefined
  touched?: boolean
  selectName?: string
  disabled?: boolean;
}

const KodBojeRepromaterijalaDropdown: React.FC<DropdownProps> = ({
  value,
  initialValue,
  onChange,
  errors,
  touched,
  selectName,
    disabled
}) => {
  const [kodBojeRepromaterijalaDropdown, setkodBojeRepromaterijalaDropdown] = useState<
    Array<Option>
  >([])
  const internalValue = initialValue ?? null

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getKodBojeDropdown()
        setkodBojeRepromaterijalaDropdown(mapData(response.data))
      } catch (error) {
        console.error('Error fetching KodBoje Materijala dropdown data:', error)
      }
    }
    fetchData()
  }, [])

  const finalValue = value ?? internalValue

  const mapData = (data) => {
    if (!data) {
      return []
    }
    return data.map((item) => ({label: item.Naziv, value: item.Id.toString()}))
  }

  return (
    <SearchableSelect
      options={kodBojeRepromaterijalaDropdown}
      value={finalValue?.toString() ?? ''}
      onChange={onChange!}
      name={selectName ?? 'kodBojeRepromaterijalaDropdown'}
      errors={errors}
      placeholder='Odaberi Kod Boje'
      touched={touched}
      disabled={!!disabled}
    />
  )
}

export default KodBojeRepromaterijalaDropdown
